export default __webpack_public_path__ + "static/media/master1.0324fda1.svg";